import { compose, withProps, withStateHandlers } from 'recompose';

import { Endpoints } from '../../../lib/LeanLinkService';
import withPagination from '../../PaginatedItems/withPagination';
import RichSelect from '../RichSelect/RichSelect';
import withOccupationNames from '../../../containers/withOccupationNames';
import debounceProp from '../../../lib/debounceProp';
import requireProps from '../../../lib/requireProps';
import { withTranslation } from 'react-i18next';

export default compose(
  withTranslation(),
  withProps(({ t }) => ({
    placeholder: t('Välj yrke'),
  })),
  withStateHandlers(({ input: { value } }) => (
    { url: Endpoints.occupations({ ids: value || undefined }) }
  ), {
    onChangeText: () => (query) => {
      if (!query) {
        return {};
      }
      return {
        url: Endpoints.occupations({ name: query }),
      };
    },
  }),
  debounceProp('url'),
  withPagination(),
  withProps(({ ids }) => ({
    occupationNamesIds: ids,
  })),
  withOccupationNames,
  requireProps(['occupationNames']),
  withProps(({ occupationNames }) => ({
    options: occupationNames ? occupationNames
      .map(({ id, name }) => ({ value: id, label: name })) : [],
  })),
)(RichSelect);
